export abstract class CoatingsEvent {}

export class CoatingsLoad extends CoatingsEvent {}
